import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";

import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";

import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from "./context";
import LinkedInWidget from "./utils/LinkedInWidget";

// Font loading utility
const loadFonts = () => {
  // Create preconnect links for better performance
  const preconnectGoogle = document.createElement('link');
  preconnectGoogle.rel = 'preconnect';
  preconnectGoogle.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnectGoogle);

  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectGstatic);

  // Load fonts asynchronously
  const fontLink = document.createElement('link');
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&family=Roboto+Serif:wght@300;400;500;600;700&family=Comfortaa:wght@300&family=Poppins:wght@300;400;500;600&family=Lisu+Bosa:wght@400;500;600;700&family=Anek+Latin&family=Inter:wght@300;400;500;600;700&family=Literata:wght@400;500;600&family=Open+Sans:wght@300;400;500;600;700&display=swap';
  fontLink.rel = 'stylesheet';
  fontLink.media = 'print'; // Load as print media first
  fontLink.onload = () => {
    fontLink.media = 'all'; // Switch to all media after load
  };
  document.head.appendChild(fontLink);
};

const Root = () => {
  useEffect(() => {
    // Load fonts immediately on component mount
    loadFonts();

    // Your existing analytics code with delay
    const GTM_ID = import.meta.env.VITE_GOOGLE_TAG_MANAGER || 'GTM-5NRJJMRH';
    const GA_KEY = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY;
    setTimeout(() => {
      if (GTM_ID) {
        TagManager.initialize({ gtmId: GTM_ID });
      }
      if (GA_KEY) {
        ReactGA.initialize(GA_KEY);
      }
    }, 3000);
  }, []);

  return (
    <BrowserRouter>
      <CookiesProvider>
        <AuthProvider>
          <LinkedInWidget />
          <App />
          <ToastContainer position="bottom-center" style={{ width: "400px" }} />
        </AuthProvider>
      </CookiesProvider>
    </BrowserRouter>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
